import { ErrorHandler, Injectable } from '@angular/core';
import { isElectronContext } from 'motion-master-client';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService implements ErrorHandler {
  readonly handleError = async (error: any) => {
    console.error(error);

    if (isElectronContext()) {
      window.electron.log(`${error.message}\n${JSON.stringify(error?.stack, null, 2)}`, 'error');
    }
  };
}
